module.exports = __webpack_public_path__ + "assets/img/glob.7e8a03e1.svg";